import { useState } from 'react';
import WeeklyShipService from './WeeklyShipService';
import { useSelector } from 'react-redux';


const useManageWeeklyShip = (contactName) => {
  const [shipDates, setShipDates] = useState([])
  const [boxUrl, setBoxUrl] = useState([])
  const [pendingUploadCount, setPendingUploadCount] = useState(0)
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const shopName = useSelector((state) => state.shop.name);


  const addWeeklyShipDate = async (data) => {
    setIsLoading(true)
    if (!data) {
      setIsLoading(false);
      return true;
    }
    try {
      const updatedData = { ...data, shop:shopName }
      const response = await WeeklyShipService.addWeeklyShipDate(updatedData);
      setIsLoading(false);
      return true
    } catch (err) {
      console.log(err)
      setError(err.response.data.message);
      setIsLoading(false);
      return false
    }
  };

  const addBoxNo = async (payload) => {
    try {
      const updatedPayload = { ...payload, shop: shopName }
      const response = await WeeklyShipService.addBoxNo(updatedPayload);
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err.response.data.message);
      setIsLoading(false);
      return err.response.data.message
    }
  };

  const refreshWeeklyShipDates = async (shipDateId) => {
    try {
      setIsLoading(true)
      const formData = { shipDateId: shipDateId, shop: shopName}
      const response = await WeeklyShipService.getWeeklyShipDate(formData);
      console.log(response.data)
      setShipDates(response.data)
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }
  
  const getUnmatchItemByShipDate = async (shipDateId) => {
    try {
      setIsLoading(true)
      const updatedFormData = { shipDateId: shipDateId, shop: shopName}
      const response = await WeeklyShipService.getUnmatchItemByShipDate(updatedFormData);
      console.log(response.data)
      setShipDates(response.data)
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const updateOrderTrackingTh = async (formData) => {
    setIsLoading(true)
    try {
      const updatedFormData = { ...formData, shop: shopName }
      const response = await WeeklyShipService.updateOrderTrackingTh(updatedFormData);
      console.log(response.data)
      setIsLoading(false);
      if(Array.isArray(response.data)){
        return response.data
      }else{
        return true
      }
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const matchWeeklyShipAndOrder = async (formData) => {
    try {
      const updatedFormData = { ...formData, shop: shopName }
      const response = await WeeklyShipService.matchWeeklyShipAndOrder(updatedFormData);
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      // null (still falsy) = the API found nothing to match, so the screen can
      // say that instead of a generic error (QA 832).
      return err?.response?.status === 404 ? null : false
    }
  }

  const cancelWeeklyShipOrderMatch = async (formData) => {
    try {
      const updatedFormData = { ...formData, shop: shopName }
      await WeeklyShipService.cancelWeeklyShipOrderMatch(updatedFormData);
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const awaitUnboxWeeklyShip = async (formData) => {
    try {
      const updatedFormData = { ...formData, shop: shopName }
      await WeeklyShipService.awaitUnboxWeeklyShip(updatedFormData);
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const getBoxNoFromProfile = async (formData) => {
    try {
      const updatedFormData = { ...formData, shop: shopName}
      const response = await WeeklyShipService.getBoxNoFromProfile(updatedFormData);
      console.log(response.data)
      setIsLoading(false);
      return response.data
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const getUnmatchBoxUrl = async (shipDate) => {
    try {
      const formData = { shipDate: shipDate, shop: shopName }
      const response = await WeeklyShipService.getUnmatchBoxUrl(formData);
      setBoxUrl(response.data)
      console.log(response)
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const getUnmatchUnpackBoxUrl = async (shipDate) => {
    try {
      const formData = { shipDate: shipDate, shop: shopName }
      const response = await WeeklyShipService.getUnmatchUnpackBoxUrl(formData);
      setBoxUrl(response.data)
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const getUnpackUnmatched = async (shipDateId, noTrackingOnly = false, shop = shopName) => {
    try {
      setIsLoading(true)
      const formData = { shipDateId, shop, noTrackingOnly }
      const response = await WeeklyShipService.getUnpackUnmatched(formData);
      setIsLoading(false);
      return Array.isArray(response.data) ? response.data : []
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return []
    }
  }

  const getUnmatchBoxUrlAir = async (shipDate) => {
    try {
      const formData = { shipDate: shipDate }
      const response = await WeeklyShipService.getUnmatchBoxUrlAir(formData);
      setBoxUrl(response.data.images)
      setPendingUploadCount(response.data.pendingCount)
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const deleteWeeklyShipDates = async (data) => {
    try {
      const updatedData = { uuids: data , shop: shopName }
      const response = await WeeklyShipService.deleteWeeklyShipDate(updatedData);
      return response.data.message
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const getArrivalList = async (shipDateId) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...shipDateId, shop: shopName}
      const response = await WeeklyShipService.getArrivalList(updatedFormData);
      console.log(response.data)
      setIsLoading(false);
      return response.data
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const getBoxNosFromOrderIds = async (orderId) => {
    setIsLoading(true);
    try {
      const updatedFormData = { orderIds: orderId, shop: shopName }
      const response = await WeeklyShipService.getBoxNosFromOrderIds(updatedFormData);
      setIsLoading(false);
      return response.data
    } catch (err) {
      setError(err);
      console.error('Error fetching box numbers:', err);
      setIsLoading(false);
      return false
    }
  }

  const uploadAirBarcodes = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = new FormData();
      for (const [key, value] of formData.entries()) {
        updatedFormData.append(key, value);
      }
      updatedFormData.append('shop', shopName);
      const response = await WeeklyShipService.uploadAirBarcodes(updatedFormData);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
      setIsLoading(false);
      return false;
    }
  }

  const createWeeklyShipAir = async (payload) => {
    setIsLoading(true);
    try {
      const updatedPayload = { ...payload, shop: shopName };
      const response = await WeeklyShipService.createWeeklyShipAir(updatedPayload);
      setIsLoading(false);
      return { success: true }
    } catch (err) {
      console.log(err)
      const message = err.response?.data?.message || 'Create failed';
      setError(message);
      setIsLoading(false);
      return { success: false, message };
    }
  }

  const attachImageToHeldBox = async (payload) => {
    try {
      await WeeklyShipService.attachImageToHeldBox(payload);
      return { success: true };
    } catch (err) {
      const message = err.response?.data?.message || 'Attach failed';
      return { success: false, message };
    }
  }

  const updateAirWeeklyShip = async (payload) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.updateAirWeeklyShip(payload);
      setIsLoading(false);
      return true;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Update failed');
      setIsLoading(false);
      return false;
    }
  }

  const deleteAirWeeklyShip = async (uuids) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.deleteAirWeeklyShip(uuids);
      setIsLoading(false);
      return response?.data?.message ?? true;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Delete failed');
      setIsLoading(false);
      return false;
    }
  }

  const getWeeklyShipByShipDateId = async (shipDateId) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.getWeeklyShipByShipDateId(shipDateId);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Failed to fetch data');
      setIsLoading(false);
      return false;
    }
  }

  const getShipmentGroupSummaryByShipDateId = async (shipDateId, includeCarryOver = false) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.getShipmentGroupSummaryByShipDateId(shipDateId, includeCarryOver);
      console.log(response.data)
      setIsLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Failed to fetch shipment group summary');
      setIsLoading(false);
      return false;
    }
  }

  const exportShipmentGroupToExcel = async (shipDateId, shipmentGroupIds, courier, paymentNotDoneGroupIds, shipDate, includeExported = false) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.exportShipmentGroupToExcel(shipDateId, shipmentGroupIds, courier, paymentNotDoneGroupIds, includeExported);
      
      // Format filename: [COURIER] [DD]_[MM] Air.xlsx
      let filename = `${courier} Air.xlsx`;
      if (shipDate) {
        const date = new Date(shipDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        filename = `${courier} ${day}_${month} Air.xlsx`;
      }
      
      // Create blob and download
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setIsLoading(false);
      return true;
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      // 404 = every selected ลัง already has an iShip label (Air Flow Plan step 11).
      if (err.response?.status === 404) return 'nothing-new';
      setError(err.response?.data?.message || 'Failed to export to Excel');
      return false;
    }
  }

  const processWeeklyShipGroupByAdmin = async (payload) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.processWeeklyShipGroupByAdmin(payload);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Failed to process group');
      setIsLoading(false);
      return false;
    }
  }

  const deActionWeeklyShip = async (weeklyShipIds) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.deActionWeeklyShip(weeklyShipIds);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Failed to de-action boxes');
      setIsLoading(false);
      return false;
    }
  }

  const addDelayArrival = async (shipDateId) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.addDelayArrival(shipDateId);
      console.log(response.data)
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const arrivalInform = async (arrivalId) => {
    setIsLoading(true);
    try {
      console.log(arrivalId)
      await WeeklyShipService.arrivalInform(arrivalId);
      setIsLoading(false);
      return true
    } catch (err) {
      setError(err);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const previewIshipImport = async (formData) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.previewIshipImport(formData);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'ไม่สามารถประมวลผลไฟล์ iShip ได้';
      console.log(err);
      setError(errorMessage);
      setIsLoading(false);
      const error = new Error(errorMessage);
      error.response = err.response;
      throw error;
    }
  }

  const applyIshipImport = async (payload) => {
    setIsLoading(true);
    try {
      const response = await WeeklyShipService.applyIshipImport(payload);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Failed to apply iShip import');
      setIsLoading(false);
      return false;
    }
  }

  const getArrivalPreview = async (data) => {
    try {
      const updatedData = { ...data, shop: shopName };
      const response = await WeeklyShipService.getArrivalPreview(updatedData);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'ไม่สามารถโหลดข้อมูลสำหรับตรวจสอบได้';
      console.log(err);
      throw new Error(errorMessage);
    }
  }

  const sendArrivalNotifications = async (data) => {
    setIsLoading(true);
    try {
      const updatedData = { ...data, shop: shopName };
      const response = await WeeklyShipService.sendArrivalNotifications(updatedData);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      // Extract error message from response (error middleware formats it as { message: ... })
      const errorMessage = err.response?.data?.message || err.message || 'ไม่สามารถส่งแจ้งเตือนได้';
      setError(errorMessage);
      console.log(err);
      setIsLoading(false);
      // Re-throw error so caller can handle it
      const error = new Error(errorMessage);
      error.response = err.response;
      throw error;
    }
  }

  const sendTestArrivalNotification = async (data) => {
    setIsLoading(true);
    try {
      const updatedData = { ...data, shop: shopName };
      const response = await WeeklyShipService.sendTestArrivalNotification(updatedData);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'ไม่สามารถส่งแจ้งเตือนทดสอบได้';
      setError(errorMessage);
      console.log(err);
      setIsLoading(false);
      const error = new Error(errorMessage);
      error.response = err.response;
      throw error;
    }
  }

  return {
    error,
    isLoading,
    shipDates,
    setShipDates,
    boxUrl,
    pendingUploadCount,
    addWeeklyShipDate,
    refreshWeeklyShipDates,
    getUnmatchItemByShipDate,
    matchWeeklyShipAndOrder,
    deleteWeeklyShipDates,
    getUnmatchBoxUrl,
    getUnmatchUnpackBoxUrl,
    getUnpackUnmatched,
    getUnmatchBoxUrlAir,
    updateOrderTrackingTh,
    addBoxNo,
    getArrivalList,
    arrivalInform,
    addDelayArrival,
    cancelWeeklyShipOrderMatch,
    getBoxNoFromProfile,
    awaitUnboxWeeklyShip,
    getBoxNosFromOrderIds,
    uploadAirBarcodes,
    createWeeklyShipAir,
    attachImageToHeldBox,
    updateAirWeeklyShip,
    deleteAirWeeklyShip,
    getWeeklyShipByShipDateId,
    processWeeklyShipGroupByAdmin,
    deActionWeeklyShip,
    getShipmentGroupSummaryByShipDateId,
    exportShipmentGroupToExcel,
    previewIshipImport,
    applyIshipImport,
    getArrivalPreview,
    sendArrivalNotifications,
    sendTestArrivalNotification
  };
}

export default useManageWeeklyShip;
